import { userDomain } from '@user';

export const useOwnerTypeMap = () => {
  return {
    [userDomain.OwnerType.Individual]: 'Физическое',
    [userDomain.OwnerType.LegalEntity]: 'Юридическое',
  };
};
